<template>
  <div>
    <template v-if="!nucleusUser()">
      <h1 class="page-header">No Access</h1>
      You do not have access to this page. Please contact HIA.
    </template>
    <div v-else id="editInterimRequest">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/requests` }">Requests</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/requests/interim-request/`+$route.params.id }">Edit Interim
        Schedule Request
      </el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>

    <div v-if="!loading">
      <h4 class="heading">Set Type, Number of Consultants and Notes
      </h4>
      <el-form v-loading="editLoading" class="editForm" label-position="top" ref="interimRequest" :rules="rules" :model="interimRequest" @submit.prevent.native>
        <el-form-item prop="interimType" label="Interim Type">
          <el-checkbox-group v-model="interimRequest.interimType" @change="editInterimRequest()">
            <el-checkbox label="Acute">Acute</el-checkbox>
            <el-checkbox label="Professional Fee">Professional Fee</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item prop="numberConsultants" label="Number of Consultants" style="width: 90%;">
          <el-input-number :key="consultantInputKey" v-model="interimRequest.numberConsultants" :min="1" @change="onNumberConsultantsChange">
          </el-input-number>
        </el-form-item>

        <el-form-item prop="notes" label="Additional Notes">
          <el-input type="textarea" :rows="4" placeholder="Notes" v-model="interimRequest.notes" @change="editInterimRequest()">
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="location" label="Location">
          <el-select v-model="interimRequest.location" @change="editInterimRequest()">
            <el-option key="Onsite" label="Onsite" value="0">
            </el-option>
            <el-option key="Remote" label="Remote" value="1">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reviewDescription" label="Review Description">
          <el-input class="reviewDescription" placeholder="Baseline, Quarterly..."
            v-model="interimRequest.reviewDescription" @change="editInterimRequest()">
          </el-input>
        </el-form-item> -->
        <!-- <el-form-item prop="dateRange" label="Requested Review Dates">
                <el-date-picker v-model="interimRequest.dateRange" type="daterange" range-separator="To"
                  start-placeholder="Start date" end-placeholder="End date" :picker-options="dateRangeOptions"
                  format="MM/dd/yyyy" value-format="MM/dd/yyyy">
                </el-date-picker>
              </el-form-item> -->
      </el-form>
    </div>
    </div>
  </div>
</template>

<script>
  import axios from '@/utilities/axios-global'
  import { mapState, mapActions } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    mixins: [HiaAuthorization],
    data: function () {
      return {
        activeStep: 0,
        loading: true,
        submitting: false,
        editLoading: false,
        recordLoading: false,
        consultantInputKey: 0,
        dateRangeOptions: {
          disabledDate(time) {
            let today = new Date(Date.now() - (24 * 60 * 60 * 1000))
            return time.getTime() < today.getTime()
          }
        },
        editScheduleRequest: {
          location: '1',
          dateRange: [],
          reviewDescription: '',
          notes: null,
          reviewType: [],
          records: [],
          proRecords: {
            type: 'pro',
            title: 'Professional Fee',
            instructions: '',
            records: []
          }
        },
        rules: {
          location: [
            { required: true, message: 'Please Select a Location', trigger: 'change' }
          ],
          dateRange: [
            { required: true, message: 'Please Select a Date Range', trigger: 'change' }
          ],
          reviewType: [
            { required: true, message: 'Please Select a Review Type', trigger: 'change' }
          ],
          reviewDescription: [
            { required: true, message: 'Please Input a Review Description', trigger: 'change' }
          ]
        }
      }
    },
    name: 'ReviweRequest',
    methods: {
      ...mapActions('requests/interim', ['GET_INTERIM_SCHEDULE_REQUEST', 'PUT_INTERIM_SCHEDULE_REQUEST']),
      showMinConsultantsMessage() {
        this.$message({
          type: 'error',
          message: 'An interim schedule request must have at least one consultant.',
          duration: 5000
        })
      },
      handleEditError(error) {
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Unable to save interim schedule request.'
        this.$message({
          type: 'error',
          message: message,
          duration: 5000
        })
        this.initialize()
      },
      onNumberConsultantsChange(val, oldVal) {
        const numericVal = val == null ? 0 : val
        if (numericVal < 1) {
          this.showMinConsultantsMessage()
          const revertTo = (oldVal != null && oldVal >= 1) ? oldVal : 1
          this.interimRequest.numberConsultants = revertTo
          this.$nextTick(() => {
            this.consultantInputKey++
          })
          return
        }
        this.editInterimRequest()
      },
      initialize() {
        if (!this.nucleusUser()) {
          this.loading = false
          return
        }
        this.loading = true
        axios.all([this.GET_INTERIM_SCHEDULE_REQUEST(this.$route.params.id)])
          .then(axios.spread(() => {
            // this.editScheduleRequest = this.reviewRequest
            this.setInterimType()
            this.$nextTick(() => {
              this.loading = false
            })
          }))
      },
      editInterimRequest() {
        let payload = {
          requestId: this.$route.params.id,
          interimRequest: this.interimRequest
        }
        this.editLoading = true
        this.PUT_INTERIM_SCHEDULE_REQUEST(payload).then(() => {
          this.editLoading = false
          this.$message({
            message: 'Interim Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.editLoading = false
          this.handleEditError(error)
        })
      },
      setInterimType() {
        this.interimRequest.interimType = []
        if (this.interimRequest.acute) {
          this.interimRequest.interimType.push('Acute')
        }
        if (this.interimRequest.profee) {
          this.interimRequest.interimType.push('Professional Fee')
        }
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId']),
      ...mapState('requests/interim', ['interimRequest'])
    },
    components: {
    }
  }
</script>

<style scoped>
/* FORM STYLE */
.editForm >>> .reviewDescription,
.editForm >>> .notes {
  width: 350px;
}
</style>
